import { useState, useEffect } from "react";
import BackLink from "../../reuseable/BackLink";
import { Button } from "../../reuseableComp.tsx/Button";
import { UndoButtons } from "../../reuseableComp.tsx/UndoButton";
import UploadIcon from "../../useIconpark/uploadIcon";
import {
  ButtonArea,
  CenteredContent,
  CenteredObject,
  Error,
  MainWrapper,
  TextArea,
  TextPtag,
} from "../Signup/style";
import { UndoUpload, UploadPath, UploadedImage, Uploadhandler } from "./style";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ImageUpload = () => {
  const [upload, setUpload] = useState(false);
  const [imageSrc, setImageSrc] = useState<any>("");
  const [isLoading, setIsLoading] = useState(false);
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const navigate = useNavigate();
  const [error, setError] = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    if (!storedToken) {
      navigate("/login", { replace: true });
    }
  });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getme`, {
        headers: Authorization,
      })
      .then((res: any) => {
        setUpload(true);
        if (res.data.result.image !== "") {
          setUpload(true);
          setImageSrc(res.data.result.image);
        } else {
          setUpload(false);
        }
      })
      .catch((err) => {
        if (err.response.status === 409) {
          navigate("/login");
        }
      });
  }, [navigate]);

  const handleUpload = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      setIsLoading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        const payload = {
          image: reader.result,
        };
        try {
          axios
            .put(`${process.env.REACT_APP_API_BASE_ENDPOINT}/image`, payload, {
              headers: Authorization,
            })
            .then((res: any) => {
              setTimeout(() => {
                setIsLoading(false);
              }, 5000);
              setImageSrc(reader.result);
              setUpload(true);
            })
            .catch((err) => {
              setIsLoading(false);
              setError("No internet");
              setTimeout(() => {
                setError("");
              }, 5000);
            });
        } catch (error) {
          console.log(error);
          console.error("Network error");
        } finally {
          setTimeout(() => {
            setIsLoading(false);
          }, 5000);
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const undoHandleUpload = () => {
    setUpload(false);
    setImageSrc("");
  };

  const NavigateToChat = () => {
    navigate("/chat");
  };

  return (
    <>
      <MainWrapper>
        <BackLink path="/" />
        <CenteredObject>
          <CenteredContent>
            <TextArea>
              <h2>Upload Picture</h2>
            </TextArea>
            <TextPtag>
              <p>Upload your Display Picture.</p>
            </TextPtag>

            <UploadPath>
              {isLoading ? (
                <>
                  <Uploadhandler>Loading</Uploadhandler>
                </>
              ) : (
                <>
                  {upload ? (
                    <>
                      <UploadedImage>
                        <img src={imageSrc} alt="Uploaded" />
                      </UploadedImage>
                    </>
                  ) : (
                    <>
                      <Uploadhandler>
                        <label htmlFor="main">
                          <UploadIcon size={70} trigger="hover" />
                        </label>
                        <input id="main" type="file" onChange={handleUpload} />
                      </Uploadhandler>
                    </>
                  )}
                </>
              )}

              <UndoUpload>
                {imageSrc && (
                  <>
                    <UndoButtons onClick={undoHandleUpload}>Edit</UndoButtons>
                  </>
                )}
              </UndoUpload>
            </UploadPath>
            <>
              {error && (
                <Error>
                  <p>{error}</p>
                </Error>
              )}
            </>
            <ButtonArea>
              <Button disabled={!imageSrc} onClick={NavigateToChat}>
                Continue
              </Button>
            </ButtonArea>
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};
export default ImageUpload;
